import { GraphQLClient } from 'graphql-request';

export const createGraphQLClient = (endpoint: string): GraphQLClient => {
  const client = new GraphQLClient(endpoint);
  return client;
};
